export const financialSupervisorColumnsA = [
  "بطاقة ائتمانية",
  "تحويل بنكي",
  "الاستقطاع",
  "اجمالي",
];

export const financialSupervisorColumnsB = [
  "اسم المشروع",
  "بطاقة ائتمانية",
  "تحويل بنكي",
  "اجمالي",
];

export const financialSupervisorColumnsC = [
  "التصنيف",
  "بطاقة ائتمانية",
  "تحويل بنكي",
  "اجمالي",
];

export const financialSupervisorColumnsD = ["اسم المشروع", "المبلغ المدفوع"];
